<div class="mbs-input">
  @if (label && id) {
    <mbs-input-label
      [boldLabel]="boldLabel"
      [description]="description"
      [descriptionClasses]="descriptionClasses"
      [disabled]="disabledState"
      [id]="id"
      [info]="info"
      [infoContainer]="infoContainer"
      [infoPlacement]="infoPlacement"
      [infoTriggers]="infoTriggers"
      [label]="label"
      [labelClasses]="labelClasses"
      [labelContentClasses]="labelContentClasses"
      [labelSize]="labelSize"
      [required]="hasRequiredValidator && showRequiredMark && !isLabelTemplate">
      <ng-content
        ngProjectAs="[prependLabel]"
        select="[prependLabel]" />

      <ng-content
        ngProjectAs="[appendLabel]"
        select="[appendLabel]" />
    </mbs-input-label>
  }

  <div class="input-group">
    @if (prependButtons || prepend) {
      <mbs-input-pre-append
        [data]="prependButtons"
        [dataTemplate]="prepend"
        [disabled]="disabledState"
        [position]="'prepend'"
        [size]="buttonsSize"
        (buttonClick)="buttonClick.emit($event)" />
    }

    <div
      class="input-group_control"
      [ngClass]="[size ? 'input-group_control-' + size : '']">
      @if (type !== 'file' && type !== 'textarea') {
        @if (showErrorsInTooltip) {
          <input
            class="form-control"
            #errorsTooltip="ngbTooltip"
            triggers="none"
            [attr.aria-describedby]="id"
            [attr.aria-labelledby]="label"
            [autoClose]="autoClose"
            [autocomplete]="autocomplete"
            [container]="container"
            [disabled]="disabledState"
            [id]="id"
            [imask]="imaskOpts"
            [imaskElement]="imaskElement"
            [maxLength]="maxLength"
            [minLength]="minLength"
            [name]="name"
            [ngbTooltip]="errorsTooltipData"
            [ngClass]="bindClasses"
            [placeholder]="placeholder"
            [placement]="placement"
            [readonly]="readonlyState"
            [tabindex]="tabindex"
            [tooltipClass]="tooltipClass"
            [type]="type"
            [value]="value"
            [unmask]="unmask"
            (blur)="handleBlur($event)"
            (focus)="handleFocus($event)"
            (input)="handleChange($any($event.target).value)" />
        } @else {
          <input
            class="form-control"
            triggers="none"
            [attr.aria-describedby]="id"
            [attr.aria-labelledby]="label"
            [autocomplete]="autocomplete"
            [disabled]="disabledState"
            [id]="id"
            [imask]="imaskOpts"
            [imaskElement]="imaskElement"
            [maxLength]="maxLength"
            [minLength]="minLength"
            [name]="name"
            [ngbTypeahead]="typeahead"
            [ngClass]="bindClasses"
            [placeholder]="placeholder"
            [placement]="placement"
            [readonly]="readonlyState"
            [tabindex]="tabindex"
            [type]="type"
            [unmask]="unmask"
            [value]="value"
            (blur)="handleBlur($event)"
            (focus)="handleFocus($event)"
            (input)="handleChange($any($event.target).value)"
            (selectItem)="handleTypeaheadItemSelected($event)" />
        }

        @if (loading) {
          <div
            class="form-control_loader"
            [ngClass]="size ? '-' + size : ''">
            <span
              class="loader"
              [ngClass]="size === 'xxs' ? 'loader-sm' : ''"></span>
          </div>
        } @else {
          @if (clearButton && value) {
            <mbs-button
              class="form-control_clear"
              [buttonType]="'reset'"
              [customClasses]="'form-control_clear-btn' + (size ? ' -' + size : '')"
              [icon]="'ico ico-Delete-text mr-0'"
              [isCtrl]="true"
              [ngClass]="size ? '-' + size : ''"
              [size]="size"
              [tabindex]="-1"
              [type]="'dark'"
              (click)="handleClear()" />
          }
        }
      }

      @if (type === 'file') {
        <div class="mbs-file">
          <input
            class="mbs-file-input"
            [attr.aria-describedby]="id"
            [attr.aria-labelledby]="label"
            [accept]="accept"
            [autocomplete]="autocomplete"
            [autofocus]="autofocus"
            [disabled]="disabledState"
            [id]="id"
            [multiple]="multiple"
            [ngClass]="bindClasses"
            [placeholder]="placeholder"
            [tabindex]="tabindex"
            [type]="'file'"
            (blur)="handleBlur($event)"
            (focus)="handleFocus($event)"
            (input)="handleChange($any($event), $any($event.target).value)"
            #fileInputElement />

          <label
            class="mbs-file-label input-group"
            [class.-disabled]="disabledState"
            [for]="id">
            <span
              class="input-group_control"
              [class.overflow-hidden]="filePlaceholderOverflow">
              <span
                class="form-control"
                [class.placeholder]="!value"
                [class.disabled]="disabledState"
                [ngClass]="bindClasses"
                [class.text-overflow]="filePlaceholderOverflow">
                {{ placeholder }}
              </span>

              @if (loading) {
                <span
                  class="form-control_loader"
                  [ngClass]="size ? '-' + size : ''">
                  <span
                    class="loader"
                    [ngClass]="size === 'xxs' ? 'loader-sm' : ''"></span>
                </span>
              }

              <!-- span is using here because of inline tags only can be used inside '<label>' element -->
              @if (clearButton && value && !errors.length) {
                <span
                  class="form-control_clear"
                  [ngClass]="size ? '-' + size : ''">
                  <span
                    class="ctrl ctrl-dark form-control_clear-btn"
                    tabindex="-1"
                    [ngClass]="size ? 'ctrl-' + size : ''"
                    (click)="handleClear($event, fileInputElement)">
                    <span class="btn-ico ico ico-Delete-text mr-0"></span>
                  </span>
                </span>
              }
            </span>

            <mbs-input-pre-append
              [dataTemplate]="append"
              [data]="[
                {
                  text: 'Browse',
                  id: id + '-browse-file',
                  type: 'secondary'
                }
              ]"
              [disabled]="disabledState"
              [position]="'append'"
              [size]="$any(size)"
              (buttonClick)="loadFileHandler($event, fileInputElement)">
            </mbs-input-pre-append>
          </label>
        </div>
      }

      @if (type === 'textarea') {
        <textarea
          class="form-control"
          [attr.aria-describedby]="id"
          [attr.aria-labelledby]="label"
          [attr.maxlength]="maxLength"
          [class.mbs-input_textarea-with-counter]="maxLength"
          [style.max-height]="maxHeight"
          [style.resize]="resize"
          [disabled]="disabledState"
          [id]="id"
          [ngClass]="bindClasses"
          [placeholder]="placeholder"
          [readonly]="readonlyState"
          [rows]="rows"
          [tabindex]="tabindex"
          [value]="value"
          (blur)="handleBlur($event)"
          (focus)="handleFocus($event)"
          (input)="handleChange($any($event.target).value)">
        </textarea>
        @if (maxLength) {
          <div class="mbs-input_textarea-counter">{{ value?.length || 0 }}/{{ maxLength }}</div>
        }

        @if (loading) {
          <div
            class="form-control_loader"
            [ngClass]="size ? '-' + size : ''">
            <span
              class="loader"
              [ngClass]="size === 'xxs' ? 'loader-sm' : ''"></span>
          </div>
        }
      }
    </div>

    @if (appendButtons || append) {
      <mbs-input-pre-append
        [data]="appendButtons"
        [dataTemplate]="append"
        [disabled]="disabledState"
        [position]="'append'"
        [size]="$any(size)"
        (buttonClick)="buttonClick.emit($event)" />
    }
  </div>

  @if (isErrorsShow && !showErrorsInTooltip) {
    <mbs-input-errors [errors]="errors" />
  }

  <ng-template #errorsTooltipData>
    <div class="text-start text-sm">
      @if (errorTooltipTitle; as title) {
        <p class="mb-3 fw-bold">
          {{ title }}
        </p>
      }

      <ul class="pl-3">
        @for (item of getErrorsArray(); track item) {
          <li class="text-danger mb-2">
            {{ $any(item).message }}
          </li>
        }
      </ul>
    </div>
  </ng-template>
</div>
